module.exports = __webpack_public_path__ + "static/media/country_ee.2a261211.webp";